// src/utils/appUtils.js

export function getAppVersion() {
  console.log('DEBUG: process.env in getAppVersion()', process.env);
  console.log('DEBUG: process.env.REACT_APP_VERSION in getAppVersion()', process.env.REACT_APP_VERSION);
  return process.env.REACT_APP_VERSION || 'NA';
}

export function getOrCreateDeviceId() {
    let deviceId = localStorage.getItem('device_id');
    if (!deviceId) {
        const array = new Uint8Array(32);
        crypto.getRandomValues(array);
        deviceId = 'desktop_' + Array.from(array, b => b.toString(16).padStart(2, '0')).join('');
        localStorage.setItem('device_id', deviceId);
    }
    return deviceId;
}

export function formatDateTime(ts) {
    const d = new Date(ts);
    return d.toLocaleString();
}

export function truncateText(text, maxLength = 80) {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '…' : text;
}

export function isImage(url) {
    return /\.(jpeg|jpg|gif|png|bmp|webp)$/i.test(url);
}

export function isVideo(url) {
    return /\.(mp4|webm|ogg)$/i.test(url);
}

export function isAudio(url) {
    return /\.(mp3|wav|ogg)$/i.test(url);
}